<template>
  <PropertyPricesPage v-if="!hasResolveErrors" />
  <HgPageNotFound v-else :theme="getCurrentPlatformTheme()" />
</template>

<script lang="ts" setup>
import { type HgSupportedLanguage, HgPageNotFound } from '@smg-real-estate/domus';
import { storeToRefs } from 'pinia';
import { computed, onServerPrefetch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

import { getGeoUrlNameByUrl } from '@/helpers/geo/geoUrlHelper';
import { getCurrentPlatformTheme } from '@/helpers/platform';
import useGeoStore from '@/stores/useGeoStore';
import useMapStore from '@/stores/useMapStore';
import PropertyPricesPage from '@/views/property-prices-page/PropertyPricesPage.vue';

const { locale } = useI18n();
const route = useRoute();
const geoStore = useGeoStore();
const mapStore = useMapStore();
const { getIaziLevelByGeoType, hasResolveErrors } = storeToRefs(geoStore);

const locationParams = computed<string>(() => route.params.location as string);
const locationQuery = computed<string>(() => route.query.zipCity as string);
onServerPrefetch(async () => {
  await fetchGeoLocationByUrlParam();
});

const fetchGeoLocationByUrlParam = async () => {
  if (locationParams.value) {
    const urlName = getGeoUrlNameByUrl({
      param: locationParams.value,
      zipQuery: locationQuery.value,
      language: locale.value as HgSupportedLanguage,
    });
    await geoStore.resolveSearchLocationByUrl(urlName, locale.value as HgSupportedLanguage);
    mapStore.setCurrentLevel(getIaziLevelByGeoType.value);
  }
};
</script>
